<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
     <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
             <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
               
                <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date
                            </label>
                            <Field name="dateAppro" type="date"  :value="getCurrentDate()"
                            class="form-control shadow-none fs-md-15 text-black"/>
                            <ErrorMessage name="dateAppro" class="text-danger"/>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Montant
                            </label>
                            <Field name="montant" type="text" v-model="montantTotal"
                            class="form-control shadow-none fs-md-15 text-black"/>
                            <ErrorMessage name="montant" class="text-danger"/>
                            </div>
                        </div>
    
                        <!-- <div class="col-md-6">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                    Fournisseur <span class="text-danger">*</span>
                                </label>
                                <Field name="client" v-slot="{ field }">
                                    <Multiselect
                                    :options="clientOptions"
                                    :searchable="true"
                                    track-by="label"
                                    label="label"
                                    v-model = "field.value"
                                    v-bind = "field"
                                    placeholder="Sélectionnez le client"
                                    />
                                </Field>
                                <ErrorMessage name="client" class="text-danger"/>
                            </div>
                        </div> -->

                        <div class="col-md-12">
                            <div class="card" style="padding:0px !important;">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <h5 class="card-title mb-0">magasins</h5>
                                    <button 
                                        type="button"
                                        class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                        @click="addApproMag"
                                    >
                                        + Magasin
                                    </button>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive">
                                    <table class="table w-100">
                                        <tbody style="width: 100% !important;">
                                            <tr v-for="(mg, index) in approMags" :key="index">
                                               
                                                <td style="margin-bottom: 5px !important;width: 100% !important;">
                                                    <Field :name="'mg_'+index" v-model="mg.magasin"  v-slot="{ field }" style="min-width: 100px !important;">
                                                        <Multiselect
                                                            v-model = "field.value"
                                                            v-bind = "field"
                                                            :options="getFilteredOptions(index)"
                                                            :searchable="true"
                                                            placeholder="Rechercher un magasin"
                                                            noResultText= "Aucun enregistrement trouvé"
                                                            noOptionsText="Tapez au moins deux caractères" />
                                                    </Field>
                                                    <ErrorMessage :name="'mg_'+index" class="text-danger"/>

                                                    <div style="clear:both"></div> <br>
                                                    <!-- PRODUITS CONDITIONNEMENT  -->
                                                    <div class="col-md-12">
                                                        <div class="card" style="padding:0px !important;">
                                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                                <h5 class="card-title mb-0">produit conditionnement</h5>
                                                                <!-- <button 
                                                                    type="button"
                                                                    class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                                                    @click="addApproMagProdCond(index)"
                                                                >
                                                                    + produit conditionnement
                                                                </button> -->
                                                            </div>
                                                            <div class="card-body">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Produit</th>
                                                                            <th>Quantité</th>
                                                                            <th>Prix Achat</th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(pro, pIndex) in mg.approMagProdConds" :key="pIndex">
                                                                            <td style="margin-bottom: 5px !important;min-width: 300px !important;">
                                                                            <Field :name="'pro_pro'+index+'_'+pIndex" v-model="pro.produitConditionnement"  v-slot="{ field }" style="min-width: 100px !important;">
                                                                                <Multiselect
                                                                                    v-model = "field.value"
                                                                                    v-bind = "field"
                                                                                    :options="getFilteredOptionsPC(index,pIndex)"
                                                                                    :searchable="true"
                                                                                    placeholder="Rechercher un produit"
                                                                                    noResultText= "Aucun enregistrement trouvé"
                                                                                    noOptionsText="Tapez au moins deux caractères" />
                                                                            </Field>
                                                                            <ErrorMessage :name="'pro_'+index+'_'+pIndex" class="text-danger"/>
                                                                            </td>
                                                                            <td>
                                                                                <Field :name="'pro_qt'+index+'_'+pIndex" type="text" v-model="pro.qteAppro"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                                                                <ErrorMessage :name="'pro_qt'+index+'_'+pIndex" class="text-danger"/>
                                                                            </td>
                                                                            <td>
                                                                                <Field :name="'pro_pa'+index+'_'+pIndex" type="text" v-model="pro.prixAchat"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                                                                <ErrorMessage :name="'pro_pa'+index+'_'+pIndex" class="text-danger"/>
                                                                            </td>
                                                                            <td>
                                                                                <Field :name="'pro_total_ligne'+index+'_'+pIndex" type="text" v-model="pro.totalLigne"
                                                                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                                                                <ErrorMessage :name="'pro_pa'+index+'_'+pIndex" class="text-danger"/>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-sm btn-outline-danger"
                                                                                    @click="removeLigne(index,pIndex)"
                                                                                >
                                                                                    x
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="card-footer">
                                                                <button 
                                                                    type="button"
                                                                    class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                                                    @click="addApproMagProdCond(index)"
                                                                >
                                                                    + produit conditionnement
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </td>
                                                    
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="clear:both;"></div><br>

                        <!-- <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Epargne <span class="text-danger">*</span>
                                </label>
                                <Field name="epargne" type="text" v-model="montantEpargne"
                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                <ErrorMessage name="epargne" class="text-danger"/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Mise <span class="text-danger">*</span>
                                </label>
                                <Field name="mise" type="text" v-model="montantMise" 
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="mise" class="text-danger"/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Montant / 20 <span class="text-danger">*</span>
                                </label>
                                <Field name="mt20" type="text" v-model="mt20"
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="mt20" class="text-danger"/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Montant total <span class="text-danger">*</span> ( {{ total }} )
                                </label>
                                <Field name="montant" type="text" v-model="montantTotal"
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="montant" class="text-danger"/>
                            </div>
                        </div> -->

                    </div>
                </div>
                
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit"
                            >
                                Enregistrer
                            </button>
                            <router-link to="/Approvisionnements" 
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler
                            </router-link>
                        </div>
                    </div>
                </div>
            </Form>
     </div>
    </div>
   
   
   </template>
   
   <script lang="ts">
   import { defineComponent, onMounted, reactive, ref, watch, toRaw } from "vue";
   import { Form, Field, ErrorMessage } from "vee-validate";
   import { error, success, showModal, hideModal, monSwal } from "../../utils/utils";
   import { useRoute, useRouter } from "vue-router";
   import ApiService from "../../services/ApiService";
   import { ProdCondVente } from "../../models/ProdCondVente";
   import * as Yup from "yup";
   import Multiselect from '@vueform/multiselect';
import { Approvisionnement } from "@/models/Approvisionnement";
   
   export default defineComponent({
     name: "AddApprovisionnement",
     components: {
       Form,
       Field,
       ErrorMessage,
       Multiselect
     },
     
     setup: (props, { emit }) => {
       const elementSchema = Yup.object().shape({
         dateAppro: Yup.string().required("Le client est obligatoire"),
       });
   
        const elementForm = ref<Approvisionnement | null>(null);
        const router = useRouter();
   
        // const empty = ref("<p><br></p>")magasinOptions
        const produitcondOptions = ref([]);
        const magasinOptions = ref([]);
        const isUPDATE = ref(false);
        const btntext = ref("Ajouter");
        const title = ref("Ajouter un approvisionnement");
        
        const approMagSave = ref<any[]>([]);
        const montantTotal = ref(0);
        const montantEpargne = ref(0);
        const montantMise = ref(0);
        const total = ref(0);
        const mt20 = ref(0);
   
  

        const approMags = reactive([{
            magasin: null,
            approMagProdConds: reactive([{
                produitConditionnement: null,
                prixAchat: null,
                totalLigne: 0,
                qteAppro: null
            }])
        }]);


        const btnTitle = async () => {
            if (isUPDATE.value) {
            title.value = "Modifier l'Approvisionnement";
            btntext.value = "Modifier";
            }else{
            title.value = "Ajouter un Approvisionnement";
            btntext.value = "Ajouter";
            }
        }

        //un watch sur qteAppro et prixAchat pour calculer le total de la ligne
        const watchelements = () => {
            approMags.forEach((mg, index) => {
                mg.approMagProdConds.forEach((cond, pIndex) => {
                    watch(() => [cond.prixAchat, cond.qteAppro],
                        ([newPrixAchat, newQteAppro]) => {
                            cond.totalLigne = (newPrixAchat ?? 0) * (newQteAppro ?? 0);
                            updateTotal();
                        }
                    );
                });
            });
        };
        watchelements();

    

        const addApproMag = () => {
            approMags.push({
                magasin: null,
                approMagProdConds: reactive([])
            });
        };

        const addApproMagProdCond = (index) => {
            approMags[index].approMagProdConds.push({
                produitConditionnement: null,
                prixAchat: null,
                totalLigne: 0,
                qteAppro: null
            });
            watchelements();
            console.log("Approvisionnement", toRaw(approMags));
        };

        const updateTotal = () => {
            montantTotal.value = approMags.reduce((total, mg) => {
                return total + mg.approMagProdConds.reduce((subTotal, cond) => {
                return subTotal + ((cond.prixAchat ?? 0) * (cond.qteAppro ?? 0));
                }, 0);
            }, 0);
        };

        const removeApproMag = (index) => {
            approMags.splice(index, 1);
        };

        const removeLigne = (index, pIndex) => {
            approMags[index].approMagProdConds.splice(pIndex, 1);
        };

        



        

        // watch(() => approMags.map((ap, index) => ({produitConditionnement: ap.ap, index})), (newValue) => {
        //     newValue.forEach(({ produitConditionnement, index }) => {
        //         if(produitConds[index].produitConditionnement){
        //             let prix : any =  produitConds[index].produitConditionnement;
        //             prix =  prix.split("-")[1]
        //             produitConds[index].qteVendu = (newValue && produitConds[index].qteVendu > 1) ? produitConds[index].qteVendu : 1;
        //             produitConds[index].prix = (prix && produitConds[index].prix != prix) ? prix : produitConds[index].prix;
        //             produitConds[index].montant = (produitConds[index].prix) ? produitConds[index].prix * produitConds[index].qteVendu : 0;
        //         }
        //     });
        //     updateTotal();
        // });

        // watch(() => produitConds.map((pc, index) => ({qteVendu: pc.qteVendu, index})), (newValue) => {
        //     newValue.forEach(({ qteVendu, index }) => {
        //         const prix =  produitConds[index].prix;
        //         produitConds[index].qteVendu = (newValue && produitConds[index].qteVendu > 1) ? produitConds[index].qteVendu : 1;
        //         produitConds[index].prix = (prix && produitConds[index].prix != prix) ? prix : produitConds[index].prix;
        //         produitConds[index].montant = (produitConds[index].prix) ? produitConds[index].prix * produitConds[index].qteVendu : 0;
        //     });
        //     updateTotal();
        // });

        // watch(() => produitConds.map((pc, index) => ({prix: pc.prix, index})), (newValue) => {
        //     newValue.forEach(({ prix, index }) => {
        //         produitConds[index].montant = (produitConds[index].prix) ? prix * produitConds[index].qteVendu : 0;
        //     });
        //     updateTotal();
        // });
         
   
        onMounted(()=> {
            fetchMagasin();
            fetchProduit();
            console.log("okok:");
        })
   
        const getCurrentDate = () => {
             const today = new Date();
             const day = String(today.getDate()).padStart(2, '0');
             const month = String(today.getMonth() + 1).padStart(2, '0');
             const year = today.getFullYear();
             return `${year}-${month}-${day}`;
        }

        const getFilteredOptions = (index) => {
            const selectedOptions = approMags.map(c => c.magasin);
            return magasinOptions.value.filter((option: any) => {
                return !selectedOptions.includes(option.value) || option.value === approMags[index].magasin;
            });
        };

        const getFilteredOptionsPC = (indexm, indexpc) => {
            const selectedOptionspc = approMags[indexm].approMagProdConds.map((c: any) => c.produitConditionnement?.split('-')[0]);
            console.log('yesyes', selectedOptionspc);
            return produitcondOptions.value.filter((option : any) => {
                option = option.value.split('-')[0];
                return !selectedOptionspc.includes(option) || option === approMags[indexm].approMagProdConds[indexpc].produitConditionnement;
            });
        };
   
        const fetchMagasin = async () => {
            try {
                const response = await ApiService.get('/magasins?limit=-1&');
                const data = response.data.data.data;
                magasinOptions.value = data.map((mag) => ({
                    value: mag.id,
                    label: mag.libelle,
                }));
            } catch (error) {
                //
            }
        };

        const fetchProduit = async () => {
            ApiService.get("/produitConditionnements?limit=-1&")
            .then(({ data }) => {
            produitcondOptions.value = data.data.data.map((p) => {
                return { 
                    value: p.id+'-'+p.prix,
                    label: p.nomComplet +' [ '+ p.conditionnement.code +' ]',
                }
            });
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
        };
   
       const showA = ref(false)
       const show = ref("0")
   
       const addElement = async (values: any, elementForm) => {

            // Supprimer dynamiquement tous les champs liés aux conditionnements
            Object.keys(values).forEach(key => {
                if (key.startsWith('mg_') || key.startsWith('pro_')) {
                    delete values[key];
                }
            });

            approMagSave.value = approMags.map((pro) => {
                const p = { ...pro }; 
                return p;
            });

            // console.log("Produits après modification:", approMags.value);
            console.log("Value:", values);
            // console.log("Produits après modification:", produitsave.value);


            // ici produit n'est rien d'aute que produit conditionnement vente
            values.approMags = approMagSave.value;
            values = values as Approvisionnement;
            console.log("values", values);
            console.log("appr", approMags);

            const result = await monSwal(
                "Vous êtes sur le point d'enregistrer un approvisionnement. Êtes-vous sûr ?",
                undefined,
                "btn btn-primary",
                undefined,
                undefined,
            );

            if(result){
                if(isUPDATE.value){
                    ApiService.put("/approvisionnement/"+values.id,values)
                    .then(({ data }) => {
                        if(data.code == 200) { 
                            success(data.message);
                            elementForm.resetForm();
                            isUPDATE.value=false;
                            btnTitle();
                        }
                    })
                    .catch(({ response }) => {
                        error(response.data.message);
                    });
                }else{
                    values.montantSansEpargne = total.value;
                    console.log("form", values);
                    ApiService.post("/approvisionnement",values)
                    .then(({ data }) => {
                        if(data.code == 201) { 
                            success(data.message);
                            router.push('/approvisionnements');
                            // elementForm.resetForm();
                        }
                    })
                    .catch(({ response }) => {
                        error(response.data.message);
                    });
                }
            }
       };
   
     
   
   
       return { 
            addElement,
            elementSchema,
            magasinOptions,
            produitcondOptions,
            getCurrentDate,
            btnTitle,
            addApproMag,
            addApproMagProdCond,
            removeApproMag,
            approMags,
            montantTotal,
            getFilteredOptions,
            getFilteredOptionsPC,
            removeLigne
            // updateTotal,
            // montantTotal,
            
            // produitConds
       };
     },
   });
   </script>
   
   <style scoped>
    .table-responsive {
        width: 100%;
    }
    .table {
        width: 100%;
    }
     table tbody td {
       padding-left: 0px !important;
     }
     .table > :not(caption) > * > * {
        padding-left: 0px !important;
     }
     .w-100 {
        width: 100% !important;
     }
   </style>
   
   